import { UserInfo } from '../types';
import apiRequest from './apiRequest';

export default async function updateUserInfo(partialUser: Partial<UserInfo>) {
  return apiRequest<{ userInfo: UserInfo }>('user', '/users/info', {
    method: 'PUT',
    body: JSON.stringify(partialUser),
  });
}
